import { render, staticRenderFns } from "./Tickets.vue?vue&type=template&id=8c7c4168&scoped=true&"
import script from "./Tickets.vue?vue&type=script&lang=js&"
export * from "./Tickets.vue?vue&type=script&lang=js&"
import style0 from "./Tickets.vue?vue&type=style&index=0&id=8c7c4168&prod&lang=scss&scoped=true&"
import style1 from "./Tickets.vue?vue&type=style&index=1&id=8c7c4168&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7c4168",
  null
  
)

export default component.exports